import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { CiQuestion } from '../models/ci-question.model';
import { CiQuestionApiService } from './ci-question-api.service';

export interface CiQuestionsResolved {
  questions: CiQuestion[];
  error: string | null;
}

/**
 * Loads the adjustment matrix before the route activates, so the form can be
 * built in one pass rather than growing controls after render.
 *
 * A failure resolves rather than rejects — the page shows a retry panel instead
 * of leaving the analyst on a dead route.
 */
export const ciQuestionsResolver: ResolveFn<CiQuestionsResolved> = () => {
  const api = inject(CiQuestionApiService);

  return api.getQuestions().pipe(
    map((questions) => ({
      questions,
      error: questions.length
        ? null
        : 'The adjustment matrix came back empty. Seed the CI questions before creating an analysis.',
    })),
    catchError((err: { message?: string }) =>
      of({
        questions: [],
        error: `Could not load the CI questions${err?.message ? ` — ${err.message}` : ''}`,
      }),
    ),
  );
};
